import { getMobileOS } from '@beef/utils';
export var setCaretPosition = function setCaretPosition(inputRef, position) {
  if (typeof position === 'undefined' || !inputRef.current) return;
  var isAndroid = getMobileOS() === 'android';
  if (isAndroid) {
    setTimeout(function () {
      var _inputRef$current;
      (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 ? void 0 : _inputRef$current.setSelectionRange(position, position);
    }, 5);
  } else {
    inputRef.current.setSelectionRange(position, position);
  }
};